export default "__VITE_ASSET__3737a6bf__"